import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import {
  clearStaffSession,
  deliveryStaffApi,
  getStaffSession,
  staffAppPath,
} from '../lib/deliveryStaffApi';

export default function DeliveryStaffProtectedRoute({ children }) {
  const [state, setState] = useState('loading'); // loading | ok | fail

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      const { token } = getStaffSession();
      if (!token) {
        if (!cancelled) setState('fail');
        return;
      }
      try {
        await deliveryStaffApi.me();
        if (!cancelled) setState('ok');
      } catch {
        clearStaffSession();
        if (!cancelled) setState('fail');
      }
    };
    run();
    return () => {
      cancelled = true;
    };
  }, []);

  if (state === 'loading') {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress sx={{ color: '#0f766e' }} />
      </Box>
    );
  }
  if (state === 'fail') {
    return <Navigate to={staffAppPath('/delivery-staff/login')} replace />;
  }
  return children;
}
